import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { Box } from "../Box";
import { palette } from "../../../styles/theme";
import { Dot } from "../Icon";
import { CopyButton } from "../Button";

interface Props {
  value: string | ReactNode;
  subElement?: ReactNode;
  withCopyButton?: boolean;
  copyValue?: string;
  withoutDot?: boolean;
}

const ListItem = ({
  value,
  subElement,
  withCopyButton,
  copyValue,
  withoutDot = true,
}: Props) => {
  return (
    <Box display="flex" alignItems="center" ml={withoutDot ? 0 : 1}>
      {!withoutDot && (
        <Dot color={palette.grey.primary} sx={{ mr: "8px" }} size={2} />
      )}
      <Typography variant="textSm" color={palette.grey.primary}>
        {value}
      </Typography>
      {subElement}
      {withCopyButton && (
        <CopyButton value={copyValue || (value as string)} sx={{ ml: "6px" }} />
      )}
    </Box>
  );
};

export default ListItem;
